import licenseModule from '../../license.module';

export default licenseModule.component('licenseRenewDetail', {
    template: require('./licenseRenewDetail.component.html'),
    controller: ['entitlementConstants', licenseRenewDetailComponent],
    bindings: {
        resolve: '<',
        callback: '&'
    }
});

function licenseRenewDetailComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    vm.$onInit = function() {
        vm.data = vm.resolve.data;
        vm.eula = false;

        vm.onlyPerpetual =
            vm.data.allocated.subscription.deviceId == 0 &&
            vm.data.allocated.subscription.premiumUserId == 0;
    };

    vm.eulaChange = function() {
        vm.callback({ value: { eula: vm.eula } });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-renew-detail/licenseRenewDetail.component.js